import { ECheckServicePromotionType } from '../../../../services/checkService';
import { EServiceId } from '../../../../types/reducers/publishTerms';

export const getNextServiceId = (
  serviceId: EServiceId,
  promotionType: ECheckServicePromotionType,
  availableServiceIds: EServiceId[],
): EServiceId => {
  // при выключенном продвижении в serviceTypes приходит DebitObject, который маппится в paid
  // после этого при включении продвижения мы отправляем его в качестве услуги и поэтому не выбирается топ по умолчанию
  const isPromotionDisabled = promotionType === ECheckServicePromotionType.noPromotion;

  // для этого кастим в top, premium или paid, проблема решится с переходом на поле promotionType
  if (isPromotionDisabled) {
    if (availableServiceIds.includes(EServiceId.top)) {
      return EServiceId.top;
    }

    if (availableServiceIds.includes(EServiceId.premium)) {
      return EServiceId.premium;
    }

    return EServiceId.paid;
  }

  // check-service для free объявок возвращает free сервис, этого значения нет в сервисах
  // пока не перейдем на promotionType, то нужен такой кастинг в paid, для выбора карточки стандарт
  if (serviceId === EServiceId.free) {
    return EServiceId.paid;
  }

  return serviceId;
};
